export const environment = {
    contactUsApiUrl: "https://cg-my-api.nt-development.dev/api/v2/ContactUs",
    loginUrl: 'https://cg-my.nt-development.dev'
};
